import { OrderCustomer } from '~/data/user/interfaces';
import { Payment } from '../payment';
import { Product, ProductVariant } from '../product';
import { UserAddress } from '../user';
import { Cart } from '../cart';

export enum OrderStatus {
    WAITING_PAYMENT = 'Waiting for payment',
    PENDING_PAYMENT = 'Pending Payment',
    PROCESSING = 'Processing',
    IN_TRANSIT = 'In transit',
    DELIVERED = 'Delivered',
    CANCELLED = 'Canceled'
}

export interface OrderItem {
    id: string;
    product: Partial<Product>;
    variant?: Partial<ProductVariant>;
    quantity: number;
}

export interface OrderStatusLog {
    name: string;
    created_at: string;
}

export interface PaymentMethod {
    number_account: number;
    name_on_card: string;
    expiration_date: string;
    cvv?: number;
}

export interface ShippingUnit {
    name: string;
    order_id: string;
    logo: string;
    expected_delivery: string;
}

export interface Order extends Cart {
    // id: string;
    order_number: string;
    status: OrderStatus;
    referer?: string;
    [x: string]: any;
}
